const $tabs = $('.etalage'),
    $tabsContent = $tabs.find('.etalage__tab-content'),
    classTab = 'etalage__tab',
    classActiveTab = 'etalage__tab--active';

// show content for active tab on pageload
if ($tabs.length && $tabsContent.length) {

    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get('tab');

    // if tab url parameter is set, show this tab
    if (myParam) {

        if ($tabs.find('[data-tab-id="' + myParam + '"]').length > 0) {
            $tabs.find('[data-tab-id="' + myParam + '"]').addClass(classActiveTab).siblings().removeClass(classActiveTab);
        } else {
            // if no active tab is set, apply active state to first tab
            if ($tabs.find('.' + classActiveTab).length === 0) {
                $tabs.find('.' + classTab + ':first-child').addClass(classActiveTab);
            }
        }

    } else {

        // if no active tab is set, apply active state to first tab
        if ($tabs.find('.' + classActiveTab).length === 0) {
            $tabs.find('.' + classTab + ':first-child').addClass(classActiveTab);
        }
    }

    let $activeTab = $tabs.find('.' + classActiveTab),
        tabID = $activeTab.data('tab-id');

    $tabsContent.find('[data-tab-id="' + tabID + '"]').show();
}

// switch tabs on user interaction
$('.' + classTab).on('click', function (e) {
    e.preventDefault();

    if (!$(this).hasClass(classActiveTab)) {

        let tabID = $(this).data('tab-id');

        window.history.pushState({Tab: tabID}, 'Tab ' + tabID, addUrlParam(document.location.search, 'tab', tabID));

        $(this).addClass(classActiveTab).siblings().removeClass(classActiveTab);
        $tabsContent.find('[data-tab-id="' + tabID + '"]').show().siblings().hide();

        // refresh slick sliders inside tab content
        $tabsContent.find('.slick-slider').slick('setPosition', 0);
    }
});

/**
 * Add a URL parameter (or changing it if it already exists)
 *
 * @param {search} string  this is typically document.location.search
 * @param {key}    string  the key to set
 * @param {val}    string  value
 *
 * For reference: https://stackoverflow.com/questions/486896/adding-a-parameter-to-the-url-with-javascript
 */
let addUrlParam = function (search, key, val) {
    let newParam = key + '=' + val,
        params = '?' + newParam;

    // If the "search" string exists, then build params from it
    if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
            params += '&' + newParam;
        }
    }

    return params;
};